import React, { useState } from 'react';
import { AddShoppingCartOutlined } from '@mui/icons-material';

import { quoteApi } from '@/main/api';
import { IPartInCart, IPartsCard, ISupplierCard } from '@/main/components/shared/card/cardShopping';
import CountControl from '@/main/components/shared/countControl/countControl';
import KOGButtonsTriggerPaintProject from '@/main/components/shared/kogButtonsTriggerPaintProject/kogbuttonsTriggerPaintProject';
import { QuoteSelectBestSupplierRequest } from '@/main/models/request';
import { useCreateOrderContext } from '@/main/screens/order/createorder/context';
import { IMAGE_DEFAULT } from '@/main/services/constants';
import { Controls } from '@/main/services/constants/constantsControl';
import { getTranslateByKey, isShowControlByElementId } from '@/main/services/utils';

import { IGridPartInternalProps } from '../../interface';
import * as S from './styles';
import { useUserReducer } from '@/main/store/user';

function AreaButtonGridPart({
  part,
  partInCart,
  displayCart = () => { },
  onClickCart = () => { }
}: IGridPartInternalProps) {
  const MAX_COUNT_MORE_SUPPLIER = 999;
  const {
    integration,
    isQuoteOpen,
    isQuoteManual,
    guidQuote
  } = useCreateOrderContext();
  const userReducer = useUserReducer();
  const showButtonAddCart = isQuoteManual
    ? isShowControlByElementId(Controls.IdAddPartToCart)
    : true;

  const [isLoadingAddToCart, setIsLoadingAddToCart] = useState<boolean>(false);

  async function callDecrementCart(
    partInCartSelected: IPartInCart,
    count: number
  ) {
    if (partInCartSelected.hasMoreSuppliers) {
      displayCart();
      throw new Error(getTranslateByKey('information.moreThanOneSupplier', true));
    }
    const { supplier, ...restPartInCartSelected } = partInCartSelected;
    onClickCart(restPartInCartSelected as any, supplier, count);
  }
  async function callIncrementCart(
    partInCartSelected: IPartInCart,
    count: number
  ) {
    if (partInCartSelected.hasMoreSuppliers) {
      displayCart();
      throw new Error(
        getTranslateByKey('information.moreThanOneSupplier', true)
      );
    }
    const { supplier, ...restPartInCartSelected } = partInCartSelected;

    onClickCart(restPartInCartSelected as any, supplier, count);
  }

  async function handleClickAddCartSupplierRecommend(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    e.stopPropagation();
    setIsLoadingAddToCart(true);
    const request = {
      quoteGuid: guidQuote,
      partGuid: part.guid,
      findMoreSuppliers: false,
      automaticQuote: false
    } as QuoteSelectBestSupplierRequest;

    await quoteApi
      .getSelectBestSupplier(request)
      .then(res => {
        const resData = res.data.result;
        const supplierRequest: ISupplierCard = {
          guid: resData.supplierGuid,
          id: resData.supplierGuid,
          isRecommended: true,
          name: resData.supplier
        };
        const partRequest: IPartsCard = {
          id: String(part.guid),
          guidPart: part.guid,
          title: part.partName,
          subTitle: '',
          description: part.partName,
          category: part.partCategoryName,
          subCategory: part.partSubCategoryName,

          partNumber: resData.partCode,

          deliveryTime: String(resData.deliveryDays),
          guidSupplierInventoryWarehouse:
            resData.supplierInventory_WarehouseGuid,
          idPartType: resData.idPartType,
          price: resData.price,
          stock: resData.stock,
          guid: resData.quoteItemGuid,
          image: IMAGE_DEFAULT,
          shippingCost: resData.shippingCost,
          guidQuoteSupplierItem: resData.guidQuoteSupplierItem
        };
        onClickCart(partRequest, supplierRequest);
      })
      .catch(() => { })
      .finally(() => setIsLoadingAddToCart(false));
  }

  if (partInCart) {
    return (
      <CountControl
        removeArrow={part.isPaintType}
        isBlocked={
          (integration && isQuoteOpen) || !showButtonAddCart
        }
        initialCount={partInCart.quantity}
        maxCount={
          partInCart.hasMoreSuppliers
            ? MAX_COUNT_MORE_SUPPLIER
            : partInCart.stock
        }
        onDecrement={count => callDecrementCart(partInCart, count)}
        onIncrement={count => callIncrementCart(partInCart, count)}
      />
    )
  }
  if (part.isPaintType) {
    return (
      <KOGButtonsTriggerPaintProject
        guidQuote={String(guidQuote)}
        part={part}
      />
    )
  }
  if (showButtonAddCart)
    return (
      <S.BoxButtonCart
        onClick={e => handleClickAddCartSupplierRecommend(e)}
        $isColumnGrid={userReducer.userPreference.preferences.isViewCard}
        className="ignore-click"
        disabled={
          (integration && isQuoteOpen) ||
          !showButtonAddCart ||
          isLoadingAddToCart
        }>
        <AddShoppingCartOutlined fontSize="medium" />
      </S.BoxButtonCart>
    );

  return <></>
}

export default AreaButtonGridPart